import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { DataGridPro, GridActionsCellItem, koKR } from '@mui/x-data-grid-pro';
import {
  Panel,
  PanelGroup,
  PanelResizeHandle,
} from 'react-resizable-panels';
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Container,
  CssBaseline,
  Grid,
  IconButton,
  LinearProgress,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import {
  Add,
  Edit,
  Delete,
  KeyboardArrowDown,
  KeyboardArrowUp,
  Visibility,
  Remove,
} from '@mui/icons-material';
import {
  FormInputText,
} from "../form";
import {
  ConfirmDialog,
} from "../dialog";
import { StyledTooltip } from "../tooltip";
import {
  CustomNoRowsOverlay,
} from "../datagrid";
import {
  dateFormat,
} from "../../utils";

const theme = createTheme();

const GSoundInsulationCalculationManagement = ({
}) => {
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [modify, setModify] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});

  const sessionUser = useSelector(state => state.session.sessionUser);

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      
    };

    fetchData();
  }, [dispatch]);

  return (
    <ThemeProvider theme={theme}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container component="main" maxWidth="false">
        <CssBaseline />
        <Box sx={{ mt: 3 }}>
          <Box sx={{ 
            height: '100%', 
            border: '1px solid #e0e0e0', 
            borderRadius: 1,
            p: 2,
            backgroundColor: '#fafafa',
          }}>
            <Typography variant="h6" gutterBottom>
              차음 성능 계산 안내
            </Typography>
            {/* 좌측 내용을 여기에 추가 */}
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" color="text.secondary">
                
              </Typography>
              <Button
                variant="contained"
                color="primary"
                sx={{ mt: 2 }}
                onClick={() => window.open("https://soundcalculator.trosifol.com/", "_blank")}
              >
                차음 성능 계산기 새 탭에서 열기
              </Button>
            </Box>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default GSoundInsulationCalculationManagement;
